export class LeaveCategory {
  _id: string;
  categoryName: string;
  SiteId: string;
  SubscriberId: string;
  createdDate?: Date; // provided by timestamps
  updatedDate?: Date; // provided by timestamps
  id?: string; // is actually model._id getter
}
